<template>
  <div>
    <div class="pageTitle"> 管理ページ </div>

    <v-btn @click="setSurvey"> Set Survey </v-btn>
    <v-btn @click="setAnswerSheets"> Set answerSheets </v-btn>

    <h1>Document Path</h1>
    <v-btn @click="getMails">
      Mails
    </v-btn>
    <v-layout row wrap>
      <v-flex md2>
        <v-text-field v-model="collection" />
      </v-flex>
      <v-flex md2>
        <v-text-field v-model="document" />
      </v-flex>
      <v-btn @click="addItem()">
        Add
      </v-btn>
    </v-layout>

    <v-layout row wrap>
      <table>
        <tr>
          <th>Delete</th>
          <th>Collection</th>
          <th>Docment</th>
        </tr>
        <tr v-for="(doc, i) in items" :key="i">
          <td class="delete-cell">
            <v-btn small @click="deleteItem(i)" icon>
              X
            </v-btn>
          </td>
          <td>{{doc.collection}}</td>
          <td>{{doc.document}}</td>
        </tr>
      </table>
    </v-layout>

    <v-layout row wrap>
      <v-flex md2>
        <v-btn @click="getItem()"> Get item</v-btn>
      </v-flex>
      <v-flex md6>
        <input @change="selectedFile" type="file" name="file">
      </v-flex>
      <v-flex md2>
        <v-btn @click="setItem"> Set Item</v-btn>
      </v-flex>
    </v-layout>

    <v-textarea :value="result" readonly box>

    </v-textarea>

    <v-layout row wrap>
      <v-flex md6>
        <input @change="selectedFile" type="file" name="file">
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
import db from '@/components/firebaseInit'
var moment = require('moment-timezone')


const questionSheet = {
  sections: [
    {
      type: "Info",
      content: '<h1>3年目フォローアップ研修サーベイ</h1><p>入社３年目スタッフに向けて研修を実施します。</p><p>研修で使用するサーベイにご協力ください。</p>',
      isShow: { subject: true, coWorker: true }
    },
    {
      type: "SelectQuestions",
      selectOptions: [
        { label: "ほとんどあてはまらない", value: "1" },
        { label: "あまりあてはまらない", value: "2" },
        { label: "どちらかと言うとあてはまらない", value: "3" },
        { label: "どちらかと言うとあてはまる", value: "4" },
        { label: "おおよそあてはまる", value: "5" },
        { label: "とてもあてはまる", value: "6" },
      ],
      questions: [
        { question: "常にメンバーの模範となる意識を持ち、行動している。", id: 1, category: "リーダーシップ" },
        { question: "メンバーから『○○さんのためなら』と思われている。", id: 2, category: "リーダーシップ" },
        { question: "チームの課題を把握し、目標達成へ向け明確な方向を示している。", id: 3, category: "リーダーシップ" },
        { question: "自らが率先して行動し、チームを牽引している。", id: 4, category: "リーダーシップ" },
        { question: "部下の存在を認め、部下への期待を伝えている。", id: 5, category: "リーダーシップ" },
        { question: "あらゆる状況において常に明るく、職場のムードメーカーである。", id: 6, category: "リーダーシップ" },
        { question: "公私問わず親身になって対応してくれる。", id: 7, category: "リーダーシップ" },
        { question: "あらゆる状況において対応できる経験がある。", id: 8, category: "リーダーシップ" },
        { question: "目標を達成するために必要なスキルや知識を自らが持つだけでなく、部下にも指導している。", id: 9, category: "リーダーシップ" },
        { question: "困難な課題にも屈しない強い精神力を持っている。", id: 10, category: "リーダーシップ" },
        { question: "今の仕事にやりがいを感じている。", id: 11, category: "入魂性" },
        { question: "自己の仕事に本気で取り組んでいる。", id: 12, category: "入魂性" },
        { question: "今やっている仕事や役割に、満足している。", id: 13, category: "入魂性" },
        { question: "今の仕事や組織の中で、十分に活かされている。", id: 14, category: "入魂性" },
        { question: "自らの志向と会社の期待が一致している。", id: 15, category: "入魂性" },
        { question: "今の仕事を通して、自己が成長できると感じている。", id: 16, category: "入魂性" },
        { question: "今の仕事をしている中で、自分なりの目標を持ち、それに向かって集中して仕事をしている。", id: 17, category: "入魂性" },
        { question: "与えられた仕事に対して、最大のパフォーマンスを発揮しようとしている。", id: 18, category: "入魂性" },
        { question: "常に目の前の仕事に懸命に取り組み、結果を出している。", id: 19, category: "入魂性" },
        { question: "毎日会社に出社することを楽しみに思っている。", id: 20, category: "入魂性" },
        { question: "常に競合他社の最新の情報を頭に入れている。", id: 21, category: "戦略性" },
        { question: "常に市場全体を見渡し、その動向に敏感である。", id: 22, category: "戦略性" },
        { question: "自社の強み・弱みを明確に認識している。", id: 23, category: "戦略性" },
        { question: "会社のビジョン・経営計画を理解している。", id: 24, category: "戦略性" },
        { question: "ビジョン・経営計画から落とし込まれたチームのビジョン・目標が明確である。", id: 25, category: "戦略性" },
        { question: "目標を達成するべくチームとしての課題を常に認識している。", id: 26, category: "戦略性" },
        { question: "チームの課題に優先順位をつけ計画的に解決している。", id: 27, category: "戦略性" },
        { question: "長期/中期/短期的な戦略をメンバーに明確に示している。", id: 28, category: "戦略性" },
        { question: "顧客の動向に敏感である。", id: 29, category: "戦略性" },
        { question: "市場や他社の動向を見極め、柔軟に戦略を組み立てている。", id: 30, category: "戦略性" },
        { question: "決めた事を自ら率先して行動する人である。", id: 31, category: "規律性" },
        { question: "会社／チームのルールを守る人である。", id: 32, category: "規律性" },
        { question: "公私のけじめをつけている。", id: 33, category: "規律性" },
        { question: "自己に非があるときは素直に謝ることが出来る人である。", id: 34, category: "規律性" },
        { question: "メンバーに対して報告・連絡・相談を徹底して行っている。", id: 35, category: "規律性" },
        { question: "メンバーの管理をしっかり行っている。", id: 36, category: "規律性" },
        { question: "自己の仕事をしっかり管理できている。", id: 37, category: "規律性" },
        { question: "仕事に必要なスキルの向上に向けた努力を常に行っている。", id: 38, category: "規律性" },
        { question: "連絡事項を常に正確に、タイムリーに伝えている。", id: 39, category: "規律性" },
        { question: "遅刻などの怠慢な行動を厳しく指導するだけでなく、自らも怠慢な行動はしない。", id: 40, category: "規律性" },

      ],
      categoryList: ["リーダーシップ", "入魂性", "戦略性", "規律性"],
      questionsOfOnePage: 5,
      subjectWords: { subject: "私は、", coWorker: "対象者は、" },
      isShow: { subject: true, coWorker: true }
    },
    {
      type: "CommentQuestions",
      questions: {
        subject: "ご自身の優れているところ/良いと思うところを入力してください。回答は最低3つ以上、１回答につき50文字以内で入力してください。",
        coWorker: "対象者の優れているところ/良いと思うところを入力してください。回答は最低3つ以上、１回答につき50文字以内で入力してください。",
      },
      maxOfComments: 5,
      minOfComments: 3,
      maxLength: 50,
      isShow: { subject: true, coWorker: true }
    },
    {
      type: "CommentQuestions",
      questions: {
        subject: "ご自身で改善すべきと思うところを入力してください。回答は最低3つ以上、１回答につき50文字以内で入力してください。",
        coworker: "対象者の改善すべきと思うところを入力してください。回答は最低3つ以上、１回答につき50文字以内で入力してください。"
      },
      maxOfComments: 5,
      minOfComments: 3,
      maxLength: 50,
      isShow: { subject: true, coWorker: true }
    },
    {
      type: "CommentQuestions",
      questions: {
        coworker: "対象者に期待していることを入力してください。回答は最低3つ以上、１回答につき50文字以内で入力してください。"
      },
      maxOfComments: 5,
      minOfComments: 3,
      maxLength: 50,
      isShow: { subject: false, coWorker: true }
    }
  ]
}
const answerSheets = [
  {
    type: "self",
    subject_name: "山岸　良介",
    subject_id: "abHj9br23bZVL201WHRNK5CQBkm2",
    user_id: "abHj9br23bZVL201WHRNK5CQBkm2",
    name: "山岸　良介",
    email: "",
    status: "未実施",
    results: "",
  },
  {
    type: "coWorker",
    subject_name: "小池　大輔",
    subject_id: "",
    user_id: "abHj9br23bZVL201WHRNK5CQBkm2",
    name: "山岸　良介",
    email: "",
    status: "未実施",
    results: "",
  }
]
export default {
  components: {
  },
  data() {
    return {
      company_id: "DnwMZlednVoBAFvzyqeN",
      survey_id: "gbfgMiGgOfW9NkwzOICS",
      uploadFile: null,
      items: [],
      collection: "",
      document: "",
      result: "",
      mailsDbRef: db.collection('mails').doc('mails')
    }
  },
  created() {

  },
  computed: {
    dbRef() {
      var dbr = db
      this.items.forEach(item => {
        dbr = dbr.collection(item.collection).doc(item.document)
      })
      return dbr
    },
  },
  methods: {
    async getMails() {
      const companyIds = []
      const querySnapshot = await db.collection('companies').get()
      const promises = []
      querySnapshot.forEach((doc) => {
        const p = db.collection('companies').doc(doc.id).collection('mails').get()
        promises.push(p)


      })
      const snapshots = await Promise.all(promises)
      const setMailPromises = []
      snapshots.forEach(snapshot => {
        snapshot.forEach((doc) => {
          const mail = doc.data()
          mail.id = doc.id
          console.log(mail)
          const p = db.collection('mails').doc(mail.id).set(mail).catch(e => console.log(e))
        })
      })
      const returns = await Promise.all(setMailPromises)


      console.log("End of function")
    },
    async setSurvey() {
      //const doc = await db.collection('companies').doc(this.company_id).collection('surveys').doc(this.survey_id).get().catch(e => console.log(e))
      await db.collection('companies').doc(this.company_id).collection('surveys').doc(this.survey_id).collection().doc().set(as)
      console.log(doc)
    },
    async setAnswerSheet(as) {
      await db.collection('companies').doc(this.company_id).collection('surveys').doc(this.survey_id).collection("answer_sheets").doc().set(as)

    },
    setAnswerSheets() {
      answerSheets.forEach(as => this.setAnswerSheet(as))
    },
    setItem() {
      const data = JSON.parse(this.result)
      this.dbRef.set(data)
        .then(function (docRef) {
          console.log("Document successfully written!");
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    },
    selectedFile(e) {
      // 選択された File の情報を保存しておく
      e.preventDefault();
      let files = e.target.files;
      this.uploadFile = files[0];
      var reader = new FileReader();
      // ファイル読み取りに失敗したとき
      reader.onerror = function () {
        alert('ファイル読み取りに失敗しました')
      }
      // ファイル読み取りに成功したとき
      reader.onload = () => {
        this.result = reader.result
        console.log(reader.result)
      }
      reader.readAsText(this.uploadFile);

    },
    addItem() {
      this.items.push({ collection: this.collection, document: this.document })
      this.collection = ""
      this.document = ""
    },
    deleteItem(index) {
      this.items.splice(index, 1)
    },
    async getItem() {
      try {
        const doc = await this.dbRef.get()
        if (doc.exists) {
          this.result = JSON.stringify(doc.data())
        } else {
          this.result = "The document doesn't exist"
        }
        console.log(doc.data())
        console.log(doc)
      } catch (e) {
        this.result = "Error:" + e
        console.log(e)
      }

    }
  }
}
</script>
